var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ArrowChevronLeftIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M4.00000164,11.9716182 C3.99923883,11.3099454 4.26395777,10.6799744 4.72650921,10.2426952 L15.1137046,0.432131679 C15.8295856,-0.212768904 16.8940889,-0.126172478 17.5112815,0.627172482 C18.1284741,1.38051744 18.0726006,2.5250542 17.3854379,3.2050083 L8.30223045,11.7836266 C8.25178963,11.8310937 8.22286488,11.8996072 8.22286488,11.9716182 C8.22286488,12.0436293 8.25178963,12.1121428 8.30223045,12.1596099 L17.3854379,20.7382282 C17.8635702,21.1689531 18.0868904,21.843918 17.9689828,22.5019392 C17.8510752,23.1599604 17.4104382,23.6978017 16.8175802,23.9073406 C16.2247222,24.1168795 15.5726561,23.9652417 15.1137046,23.5111048 L4.73023489,13.7035412 C4.26656377,13.2655132 4.00058813,12.6346883 4.00000164,11.9716182 Z" })))); };
export var ArrowChevronLeft = styled(ArrowChevronLeftIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=ArrowChevronLeft.js.map